module.exports = __webpack_public_path__ + "static/media/he.a4d4a60e.png";